define((require) => {
    "use strict";

    const Promise     = require("shared/util/Promise");
    /**
     * @class {ChannelChangesInfo}
     *
     * Class handling channel changes in Publish Tab.
     */
    class ChannelChangesInfo {
        constructor() {
            this.addedChannels = new Set();
            this.updatedChannels = new Map();
            this.deletedChannels = new Map();
        }

        handleAdd(channel) {
            this.addedChannels.add(channel);
        }

        handleUpdate(channel) {
            const channelId = channel.get("id");
            if (channelId && !this.updatedChannels.has(channelId)) {
                this.updatedChannels.set(channelId, channel);
            }
        }

        handleDelete(channel) {
            // if channel already exists
            const channelId = channel.get("id");
            if (channelId) {
                if (this.updatedChannels.has(channelId)) {
                    this.updatedChannels.delete(channelId);
                }
                this.deletedChannels.set(channelId, channel);

                // if channel was newly added and not saved yet
            } else {
                this.addedChannels.delete(channel);
            }
        }

        clear() {
            this.addedChannels.clear();
            this.updatedChannels.clear();
            this.deletedChannels.clear();
        }

        hasAny() {
            return this.addedChannels.size > 0 || this.updatedChannels.size > 0 || this.deletedChannels.size > 0;
        }

        /**
         * Returns current modified channels as a list.
         *
         * @returns {Array} Array of {@link Channel}s.
         */
        asList() {
            const {addedChannelsList, updatedChannelsList, deletedChannelsList} = this._convertToLists();
            return addedChannelsList.concat(updatedChannelsList, deletedChannelsList);
        }

        /**
         * Returns a promise with all actions that should be performed on channels, including creation , deletion and updates.
         *
         * @returns {Promise} promise resolving with information about the channels taht need to be read or modified by the backend.
         */
        applyChanges() {
            const {addedChannelsList, updatedChannelsList, deletedChannelsList} = this._convertToLists();

            const addedAndUpdatedChannels = addedChannelsList.concat(updatedChannelsList);
            const promises = [];

            addedAndUpdatedChannels.forEach((channel) => {
                promises.push(() => channel.save());
            });

            deletedChannelsList.forEach((channel) => {
                promises.push(() => channel.destroy());
            });

            return this._executeChannelActions(promises);
        }


        /**
         * Converts Sets and Maps to List, in absence of support of spread operator in IE11.
         *
         * @returns {Object} object containing information about added, updated and deleted channels as arrays.
         */
        _convertToLists() {
            const addedChannelsList = [];
            const updatedChannelsList = [];
            const deletedChannelsList = [];

            // Cannot use [...this.addedChannels} because of IE11...
            this.addedChannels.forEach((addedChannel) => {
                addedChannelsList.push(addedChannel);
            });

            this.updatedChannels.forEach((updatedChannel) => {
                updatedChannelsList.push(updatedChannel);
            });

            this.deletedChannels.forEach((deletedChannel) => {
                deletedChannelsList.push(deletedChannel);
            });

            return {
                addedChannelsList,
                updatedChannelsList,
                deletedChannelsList
            };
        }

        /**
         * Executes all sequential requests regardless of success of failure.
         *
         * @returns {Promise} promise resolving with information about the channels being executed sequentially.
         */
        _executeChannelActions(promiseFactories) {
            const task = promiseFactories.shift();
            if (task) {
                return task().then(() => this._executeChannelActions(promiseFactories))
                    .fail(() => this._executeChannelActions(promiseFactories));
            }

            return Promise.resolved();
        }
    }

    return ChannelChangesInfo;
});



// WEBPACK FOOTER //
// ./src/editor/ui/publish/channelSetup/ChannelChangesInfo.js